var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "label-modal",
    attrs: {
      title: (_vm.isEdit ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("面板"),
      visible: _vm.visible,
      width: 600
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    key: _vm.timer1,
    ref: "dataFormRef",
    attrs: {
      model: _vm.formData,
      rules: _vm.formFules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("面板名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("面板名称")
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("面板说明")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("面板说明"),
      maxLength: 50
    },
    model: {
      value: _vm.formData.panelDescription,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "panelDescription", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.panelDescription"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_vm.formData.dictionariesConfig == "NO" ? _c("a-select", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("标识"),
      disabled: _vm.isEdit ? true : false
    },
    on: {
      change: _vm.markChange
    },
    model: {
      value: _vm.formData.mark,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mark", $$v);
      },
      expression: "formData.mark"
    }
  }, _vm._l(_vm.MARKLIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1) : _vm._e(), _vm.isEdit && _vm.formData.dictionariesConfig == "YES" || !_vm.isEdit ? _c("a-checkbox", {
    staticClass: "marginL15",
    attrs: {
      checked: _vm.dictionariesState,
      disabled: _vm.isEdit ? true : false
    },
    on: {
      change: _vm.onDictionariesState
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("从字典中配置")) + " ")]) : _vm._e()], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("菜单"),
      prop: "menu"
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.menuChange
    },
    model: {
      value: _vm.formData.menu,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "menu", $$v);
      },
      expression: "formData.menu"
    }
  }, _vm._l(_vm.MENULIST, function (item) {
    return _c("a-radio", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value)) + " ")]);
  }), 1)], 1), _vm.formData.menu == "DATA_BOARD" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("面板分类"),
      prop: "type"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("面板分类")
    },
    model: {
      value: _vm.formData.type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "type", $$v);
      },
      expression: "formData.type"
    }
  }, _vm._l(_vm.TYPELIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("使用角色"),
      prop: "role"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("使用角色"),
      disabled: _vm.isEdit ? true : false
    },
    on: {
      change: _vm.roleChange
    },
    model: {
      value: _vm.formData.role,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "role", $$v);
      },
      expression: "formData.role"
    }
  }, _vm._l(_vm.ROLELIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1), _vm.formData.dictionariesConfig == "NO" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("数据源"),
      prop: "sources"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请先选择角色以及标识再选择数据源"),
      disabled: _vm.sourcesDisabled(_vm.formData)
    },
    model: {
      value: _vm.formData.sources,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sources", $$v);
      },
      expression: "formData.sources"
    }
  }, _vm._l(_vm.SOURCELIST, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("备注"),
      maxLength: 50
    },
    model: {
      value: _vm.formData.remarks,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "remarks", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.remarks"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      width: "60px"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), (_vm.isEdit ? false : true) ? _c("a-checkbox", {
    staticClass: "marginL15",
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")))]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };